/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Customer } from "../Customers";
import { Order } from "../Orders";
import { ProductBase } from "../Products";
import { TagZone } from "../Store/TagZone";
/**
 * Company inventory product model
 */

export class CompanyInventoryProduct extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getCustomerId = () => {
      return this.model.customerId;
    };

    this.getZoneId = () => {
      return this.model.zoneId;
    };

    this.getProductBaseId = () => {
      return this.model.productBaseId;
    };

    this.getIsExist = () => {
      return Boolean(this.model.isExist);
    };

    this.getRelatedOrderId = () => {
      return this.model.relatedOrderId;
    };

    this.getRelatedEvents = () => {
      return this.model.relatedEvents;
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };

    this.getTagZone = zone => {
      return this.getRelation('zone', TagZone, zone);
    };

    this.getProductBase = productBase => {
      return this.getRelation('productBase', ProductBase, productBase);
    };

    this.getOrder = order => {
      return this.getRelation('order', Order, order);
    };
  }

  /**
   * Create company inventory product
   *
   * @param {object} object
   *
   * @return {CompanyInventoryProduct}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list inventory products
   *
   * @param {object} objects
   *
   * @return {Array.<CompanyInventoryProduct>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map inventory products
   *
   * @param {Array.<object>} objects
   * @param {function(CompanyInventoryProduct): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get id
   *
   * @return {number}
   */


}